<template>
  <Modal
    :title="$t('financial.updatePayments.singlePayment.modalTitle')"
    name="APPOINTMENT_SINGLE_PAYMENT_MODAL"
    width="420"
    actions
  >
    <template v-slot:body>
      <v-form v-model="valid" ref="paymentForm" lazy-validation>
        <v-text-field
          v-model.lazy="value"
          v-money="catalogCurrency()"
          :label="$t('financial.updatePayments.singlePayment.value')"
          :rules="[rules.required]"
          class="amount amount--small inputAmount mx-auto"
          hide-details="auto"
          outlined
        />

        <v-divider class="mt-6 mb-0" />

        <v-row align="center">
          <v-col>
            <HCheckbox
              v-model="chargeRealEstate"
              :label="$t('financial.updatePayments.singlePayment.chargeRealEstate')"
              class="mt-n1"
            />
          </v-col>
          <v-col cols="1">
            <v-icon color="grey" small>
              mdi-ray-start-arrow
            </v-icon>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="customPaymentTax"
              :label="$t('financial.updatePayments.singlePayment.customPaymentTax')"
              :disabled="!chargeRealEstate"
              :rules="[rules.minAmount, rules.maxAmount]"
              class="amount amount--small"
              hide-details="auto"
              maxlength="3"
              type="number"
              suffix="%"
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="movementReason"
              :label="$t('movement.label.reason')"
              :items="customMovementReasons"
              item-text="name"
              item-value="value"
              :rules="chargeRealEstate ? [rules.required] : []"
              :disabled="!chargeRealEstate"
              outlined
            />
          </v-col>
        </v-row>

        <v-divider class="mt-0 mb-5" />

        <HCheckbox
          v-model="usePreviousContract"
          :label="$t('financial.updatePayments.label.useOriginalContract')"
        />

        <v-divider class="mt-7 mb-6" />

        <v-textarea
          :label="$t('financial.updatePayments.singlePayment.description')"
          v-model="description"
          hide-details="auto"
          outlined
          rows="3"
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        class="mr-5"
        elevation="0"
        large
        text
      >
        {{ $t('create.cancel') }}
      </v-btn>

      <v-btn
        @click="save"
        :loading="isCreatingSinglePayment"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('create.generateSinglePayment') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { required } from '@/util/errorHandling'
import { clearCurrency } from '@/util/helpers'
import { currency } from '@/util/enums'
import { VMoney } from 'v-money'
import { customMovementReasons } from '@/components/movement/movementCategoriesAndReasons'
import { catalogCurrency } from '@/util/catalog'

import Modal from '@/components/app/Modal'
import HAmount from '@/components/app/HAmount'
import HCheckbox from '@/components/app/HCheckbox'

export default {
  name: 'SinglePayment',

  components: {
    HCheckbox,
    HAmount,
    Modal,
  },

  directives: {
    money: VMoney
  },

  props: {
    appointmentId: {
      required: true,
    },
  },

  computed: {
    ...mapGetters([
      'appointment',
      'singlePaymentDialog',
      'isCreatingSinglePayment',
    ]),

    minValue() {
      return this.handleSetCustomPaymentTax ? 1 : 0
    }
  },

  watch: {
    chargeRealEstate(status) {
      if (status === false) this.customPaymentTax = 0
    }
  },

  methods: {
    ...mapActions(['createCustomPayment']),
    ...mapMutations(['closeAllModals']),

    save() {
      if (!this.$refs.paymentForm.validate()) return

      const singlePayment = {
        appointment_id: this.appointmentId,
        value: clearCurrency(this.value),
        charge_real_estate: this.chargeRealEstate,
        custom_payment_tax: this.customPaymentTax,
        description: this.description,
        use_previous_contract: this.usePreviousContract,
        movement_reason: this.movementReason
      }

      this.createCustomPayment(singlePayment)
    },

    closeModal() {
      this.closeAllModals()
    },
  },

  data() {
    return {
      valid: false,
      isLoading: false,

      value: 0,
      customPaymentTax: 0,
      chargeRealEstate: false,
      usePreviousContract: false,
      description: '',
      customMovementReasons: customMovementReasons,
      movementReason: null,

      // currency,
      catalogCurrency,
      minAmount: 0,
      maxAmount: 100,

      rules: {
        required,
        minAmount: (value) => {
          if (value != '') {
            return (
              parseInt(value) >= this.minAmount ||
              this.$t('rules.minAmount', { value: this.minAmount })
            )
          }

          return true
        },
        maxAmount: (value) => {
          if (value > this.maxAmount && value != '') {
            return (
              parseInt(value) < this.maxAmount ||
              this.$t('rules.maxAmount', { value: this.maxAmount })
            )
          }

          return true
        },
      },
    }
  },
}
</script>
